interface ISiteInfo {
  siteID: number;
  externalID: string;
  name: string;
  city: string;
  region: string;
  latitude: number;
  longitude: number;
  networkName: string;
  screenCount: number;
  physicalScreenCount: number;
}

interface ISiteInfoAPI {
  site_id: number;
  site_external_id: string;
  site_name: string;
  city: string;
  region: string;
  latitude: number;
  longitude: number;
  network: string;
  units_count: number;
  physical_unit_count: number;
}

export default class SiteInfo implements ISiteInfo {
  siteID: number;

  externalID: string;

  name: string;

  city: string;

  region: string;

  latitude: number;

  longitude: number;

  networkName: string;

  screenCount: number;

  physicalScreenCount: number;

  constructor(
    siteID: number,
    externalID: string,
    name: string,
    city: string,
    region: string,
    latitude: number,
    longitude: number,
    networkName: string,
    screenCount: number,
    physicalScreenCount: number,
  ) {
    this.siteID = siteID;
    this.externalID = externalID;
    this.name = name;
    this.city = city;
    this.region = region;
    this.latitude = latitude;
    this.longitude = longitude;
    this.networkName = networkName;
    this.screenCount = screenCount;
    this.physicalScreenCount = physicalScreenCount;
  }

  static fromApi(apiObject: ISiteInfoAPI): SiteInfo {
    return new SiteInfo(
      apiObject.site_id,
      apiObject.site_external_id,
      apiObject.site_name,
      apiObject.city,
      apiObject.region,
      apiObject.latitude,
      apiObject.longitude,
      apiObject.network,
      apiObject.units_count,
      apiObject.physical_unit_count,
    );
  }

  get dataRow(): (string | number)[] {
    return [
      this.externalID,
      this.name,
      this.city,
      this.region,
      this.latitude,
      this.longitude,
      this.networkName,
      this.screenCount,
    ];
  }

  static fromObject(obj: ISiteInfo): SiteInfo {
    return Object.assign(new SiteInfo(0, '', '', '', '', 0, 0, '', 0, 0), obj);
  }
}
